import script from "./CZoneAnnouncement.vue?vue&type=script&setup=true&lang=ts"
export * from "./CZoneAnnouncement.vue?vue&type=script&setup=true&lang=ts"

import "./CZoneAnnouncement.vue?vue&type=style&index=0&id=3eba1b1b&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eba1b1b"]])

export default __exports__